/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './SearchChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService#search
 */
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'search',
  args: ['scoringConfig', 'pageLength', 'search', 'include', 'categories', 'hubSpotSoftware', 'levels', 'businessObjectives', 'useCases', 'durations', 'languages', 'contentTypes', 'professorIds', 'hasAwardsOnly', 'partnersOnly', 'shouldFilterDeprecated', 'sortingType', 'offset'],
  fetcher(request) {
    return chirpClient.call(References.searchRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService#searchEvaluation
 */
export const SEARCH_EVALUATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'searchEvaluation',
  args: ['scoringConfig', 'search', 'include', 'categories', 'hubSpotSoftware', 'levels', 'businessObjectives', 'useCases', 'durations', 'languages', 'contentTypes', 'professorIds', 'hasAwardsOnly', 'partnersOnly', 'shouldFilterDeprecated', 'sortingType', 'pageLength', 'offset'],
  fetcher(request) {
    return chirpClient.call(References.searchEvaluationRpc, {
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService#sendFeedback
 */
export const SEND_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'sendFeedback',
  args: ['correlationId', 'resultMLOptionId', 'contentContainerType'],
  fetcher(request) {
    return chirpClient.call(References.sendFeedbackRpc, {
      request
    });
  }
});